export const openModal = (url: string): void => {
  window.Rails.ajax({
    type: 'GET',
    url: url,
    dataType: 'script',
  })
}
